import { render, staticRenderFns } from "./ViewPostFavorite.vue?vue&type=template&id=7a1fbb30&"
import script from "./ViewPostFavorite.vue?vue&type=script&lang=js&"
export * from "./ViewPostFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports